module.exports = __webpack_public_path__ + "img/Reservations_Empanadas-w.bd82aa5a.jpg";